var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed-center text-center"},[_c('p',[_c('img',{staticStyle:{"width":"30vw","max-width":"150px"},attrs:{"src":require("../../assets/logo.png")}})]),_c('p',{staticClass:"text-faded"},[_vm._v("Unfortunately the ICP store is only available within Australia and New Zealand.")])])
}]

export { render, staticRenderFns }